/**
 * @file Helper file for AI Talk
 * */

import type { Voice } from '@@/types'

const DEFAULT_ENGLISH_VOICE = {
  languageCode: 'en-US',
  name: 'en-US-Neural2-C',
  languageName: 'English (US)',
}

const AUTODETECT_VOICE = {
  languageCode: 'auto',
  name: 'auto',
  languageName: 'Auto-detect',
}

const voices: Voice[] = [
  AUTODETECT_VOICE,
  {
    languageCode: 'am-ET',
    name: 'am-ET-Wavenet-A',
    languageName: 'Amharic',
  },
  {
    languageCode: 'ar-XA',
    name: 'ar-XA-Wavenet-A',
    languageName: 'Arabic',
  },
  {
    languageCode: 'bn-IN',
    name: 'bn-IN-Wavenet-A',
    languageName: 'Bangla',
  },
  {
    languageCode: 'cmn-CN',
    name: 'cmn-CN-Wavenet-A',
    languageName: 'Chinese (Mandarin)',
  },
  {
    languageCode: 'cmn-TW',
    name: 'cmn-TW-Wavenet-A',
    languageName: 'Chinese (Taiwanese)',
  },
  {
    languageCode: 'cs-CZ',
    name: 'cs-CZ-Wavenet-A',
    languageName: 'Czech',
  },
  {
    languageCode: 'da-DK',
    name: 'da-DK-Neural2-D',
    languageName: 'Danish',
  },
  {
    languageCode: 'de-DE',
    name: 'de-DE-Neural2-A',
    languageName: 'German',
  },
  {
    languageCode: 'el-GR',
    name: 'el-GR-Wavenet-A',
    languageName: 'Greek',
  },
  {
    languageCode: 'en-AU',
    name: 'en-AU-Neural2-A',
    languageName: 'English (Australia)',
  },
  {
    languageCode: 'en-GB',
    name: 'en-GB-Neural2-A',
    languageName: 'English (UK)',
  },
  DEFAULT_ENGLISH_VOICE,
  {
    languageCode: 'es-ES',
    name: 'es-ES-Neural2-A',
    languageName: 'Spanish',
  },
  {
    languageCode: 'es-US',
    name: 'es-US-Neural2-A',
    languageName: 'Spanish (US)',
  },
  {
    languageCode: 'fi-FI',
    name: 'fi-FI-Wavenet-A',
    languageName: 'Finnish',
  },
  {
    languageCode: 'fil-PH',
    name: 'fil-ph-Neural2-A',
    languageName: 'Filipino',
  },
  {
    languageCode: 'fr-CA',
    name: 'fr-CA-Neural2-A',
    languageName: 'French (Canada)',
  },
  {
    languageCode: 'fr-FR',
    name: 'fr-FR-Neural2-A',
    languageName: 'French',
  },
  {
    languageCode: 'gu-IN',
    name: 'gu-IN-Wavenet-A',
    languageName: 'Gujarati',
  },
  {
    languageCode: 'he-IL',
    name: 'he-IL-Wavenet-A',
    languageName: 'Hebrew',
  },
  {
    languageCode: 'hi-IN',
    name: 'hi-IN-Neural2-A',
    languageName: 'Hindi',
  },
  {
    languageCode: 'hu-HU',
    name: 'hu-HU-Wavenet-A',
    languageName: 'Hungarian',
  },
  {
    languageCode: 'id-ID',
    name: 'id-ID-Wavenet-A',
    languageName: 'Indonesian',
  },
  {
    languageCode: 'it-IT',
    name: 'it-IT-Neural2-A',
    languageName: 'Italian',
  },
  {
    languageCode: 'ja-JP',
    name: 'ja-JP-Neural2-B',
    languageName: 'Japanese',
  },
  {
    languageCode: 'kn-IN',
    name: 'kn-IN-Wavenet-A',
    languageName: 'Kannada',
  },
  {
    languageCode: 'ko-KR',
    name: 'ko-KR-Neural2-A',
    languageName: 'Korean',
  },
  {
    languageCode: 'ml-IN',
    name: 'ml-IN-Wavenet-A',
    languageName: 'Malayalam',
  },
  {
    languageCode: 'mr-IN',
    name: 'mr-IN-Wavenet-A',
    languageName: 'Marathi',
  },
  {
    languageCode: 'ms-MY',
    name: 'ms-MY-Wavenet-A',
    languageName: 'Malay',
  },
  {
    languageCode: 'nb-NO',
    name: 'nb-NO-Wavenet-A',
    languageName: 'Norwegian',
  },
  {
    languageCode: 'nl-BE',
    name: 'nl-BE-Wavenet-A',
    languageName: 'Dutch',
  },
  {
    languageCode: 'nl-NL',
    name: 'nl-NL-Wavenet-A',
    languageName: 'Dutch (Netherlands)',
  },
  {
    languageCode: 'pa-IN',
    name: 'pa-IN-Wavenet-A',
    languageName: 'Punjabi',
  },
  {
    languageCode: 'pl-PL',
    name: 'pl-PL-Wavenet-A',
    languageName: 'Polish',
  },
  {
    languageCode: 'pt-BR',
    name: 'pt-BR-Neural2-A',
    languageName: 'Portuguese (Brazil)',
  },
  {
    languageCode: 'pt-PT',
    name: 'pt-PT-Wavenet-A',
    languageName: 'Portuguese (Portugal)',
  },
  {
    languageCode: 'ro-RO',
    name: 'ro-RO-Wavenet-A',
    languageName: 'Romanian',
  },
  {
    languageCode: 'ru-RU',
    name: 'ru-RU-Wavenet-A',
    languageName: 'Russian',
  },
  {
    languageCode: 'sk-SK',
    name: 'sk-SK-Wavenet-A',
    languageName: 'Slovak',
  },
  {
    languageCode: 'sv-SE',
    name: 'sv-SE-Wavenet-A',
    languageName: 'Swedish',
  },
  {
    languageCode: 'ta-IN',
    name: 'ta-IN-Wavenet-A',
    languageName: 'Tamil',
  },
  {
    languageCode: 'th-TH',
    name: 'th-TH-Neural2-C',
    languageName: 'Thai',
  },
  {
    languageCode: 'tr-TR',
    name: 'tr-TR-Wavenet-A',
    languageName: 'Turkish',
  },
  {
    languageCode: 'uk-UA',
    name: 'uk-UA-Wavenet-A',
    languageName: 'Ukrainian',
  },
  {
    languageCode: 'ur-IN',
    name: 'ur-IN-Wavenet-A',
    languageName: 'Urdu',
  },
  {
    languageCode: 'vi-VN',
    name: 'vi-VN-Neural2-A',
    languageName: 'Vietnamese',
  },
]

const EXAMPLES: Record<string, string[]> = {
  'am-ET': [
    'የጎልደን ጌት ድልድይ በሳን ፍራንሲስኮ ባሕር እና በአትላንቲክ ውቅያኖስ መሻገሪያ ከፍተኛ ድልድይ ነው። እርሱ በሳን ፍራንሲስኮ ካሊፎርኒያ ከተማ እና ማሪን ካውንቲ በሰሜን ያገናኝ። ለአስደናቂ እምቅ እና ለአርት ዲኮ እንደማቆሚያ በተቀረጸ፣ እንደ ሳን ፍራንሲስኮ ምልክት እና በዓለም እጅግ ተገርፎ እንደ አንዱ የተከበረ ትምህርት ነው።',
    'የኢትዮጵያ ታላቅ ባሕር ከታላቁ የኢትዮጵያ እና የሱዳን እስከ እስክ ድርሰቶች በኩርካሽ ማዶ የሚሄድ ነው። በታላቅ ደስታ እና በማኅበረሰቡ የምናውቅበት በዓለም እጅግ ታላቅ ነው።',
    'ሳምሶን እና ዳልላ እንደ አንድ የእንግሊዝ ታምሪ ተነባቢና ተመስጋኛ የታላቅ አንበሳ ማእከለይ በኩራን አንድ ታምሪ ነበር።',
  ],
  'ar-XA': [
    'تعد الأهرامات المصرية واحدة من أعظم الإنجازات الهندسية في التاريخ. بُنيت كمدافن للفراعنة، ولا يزال علماء الآثار يبحثون عن أسرارها المخفية. يمكن أن تحمل الأهرامات إجابات على أسئلة حول الحضارة المصرية القديمة، وتبقى شاهداً على براعة البشرية وإبداعها.',
    "القطار السريع في اليابان، المعروف باسم 'شنكانسن'، يمكن أن يصل سرعته إلى 320 كيلومتر في الساعة! إنه ليس فقط وسيلة رائعة للتنقل، بل تجربة ممتعة تشبه ركوب الأفعوانية.",
    'برج خليفة في دبي هو أطول برج في العالم، بطول 828 مترًا! من الأعلى يمكنك رؤية منظر رائع للمدينة بأكملها والصحراء المحيطة بها. إنه مكان مذهل للتعلم عن الهندسة والعمارة.',
  ],
  'bn-IN': [
    'সুন্দরবন বিশ্বের বৃহত্তম ম্যানগ্রোভ বন যা বাংলাদেশ এবং ভারতের সীমান্ত বরাবর বিস্তৃত। এটি বাঘ, কুমির এবং অসংখ্য পাখি সহ বিভিন্ন বন্যপ্রাণীর আবাসস্থল। সুন্দরবনের অপরূপ সৌন্দর্য ও জীববৈচিত্র্য প্রকৃতির এক অনন্য উদাহরণ।',
    'বাংলাদেশের ঢাকার বাতাসে পান্থকুঞ্জ একটি বিশালাকৃতি বাগান যেখানে বিভিন্ন ধরনের ফুল ও উদ্ভিদ রয়েছে। এটি একটি শীতল এবং সুন্দর জায়গা যেখানে মানুষ প্রায়শই অবসর সময় কাটাতে যায়।',
    'বাংলাদেশের সেন্ট মার্টিন দ্বীপ একটি ছোট এবং সুন্দর দ্বীপ যা নাফ নদীর মোহনায় অবস্থিত। এখানকার সাদা বালির সৈকত এবং পরিষ্কার নীল পানি দর্শকদের মনমুগ্ধ করে।',
  ],
  'cmn-CN': [
    '长城是中国古代最伟大的工程之一。它不仅是防御工事，也是文化交流的桥梁。每一块砖都讲述着古代劳动人民的智慧和汗水。如今，长城象征着中华民族的坚韧和毅力，吸引着世界各地的游客。',
    '熊猫是中国的国宝，它们主要生活在四川的竹林里。熊猫以其可爱的外表和独特的黑白相间的毛发闻名，吸引了大量的游客和研究者。',
    '紫禁城是中国明清两代的皇家宫殿，位于北京的中心。宫殿的建筑风格和艺术品展示了中国古代建筑的精美和辉煌。',
  ],
  'cmn-TW': [
    '台灣的太魯閣國家公園以其壯麗的峽谷和大理石峭壁聞名。這裡的景觀變化多端，每一處都展示了大自然的鬼斧神工。遊客在這裡可以體驗到與世隔絕的寧靜，並且深入了解台灣豐富的自然遺產。',
    '台灣的夜市文化非常有名。從台北的士林夜市到高雄的六合夜市，各種美食攤位和遊戲攤位讓人目不暇接，是台灣夜生活的一大特色。',
    '阿里山以其壯麗的日出和雲海景觀著名。每年都有大量遊客登上阿里山觀賞日出，並體驗台灣的美麗自然景觀。',
  ],
  'cs-CZ': [
    'Pražský hrad je největším starobylým hradem na světě a sídlem českých králů a prezidentů. Je to komplex historických budov, katedrál a zahrad, které vyprávějí příběh českého národa. Každá návštěva hradu je cestou do minulosti, kde se historie a současnost setkávají.',
    'Karlův most v Praze je jedním z nejznámějších mostů na světě. Postavený ve 14. století, je lemovaný sochami a poskytuje nádherný výhled na Vltavu a Pražský hrad. Je to oblíbené místo turistů i místních obyvatel.',
    'Český Krumlov je malebné městečko na jihu České republiky. Jeho historické centrum je zapsáno na seznamu UNESCO a láká návštěvníky svou zachovalou architekturou, hradem a krásnými uličkami.',
  ],
  'da-DK': [
    'Københavns Tivoli er en af de ældste forlystelsesparker i verden, fyldt med historie og magi. Parken kombinerer moderne forlystelser med klassisk charme og er et symbol på dansk kultur og kreativitet. Her kan besøgende opleve alt fra rutsjebaner til balletforestillinger, alt i hjertet af København.',
    'Den Lille Havfrue i København er en ikonisk statue baseret på H.C. Andersens eventyr. Statuen sidder på en sten ved vandkanten og er en af Danmarks mest berømte turistattraktioner.',
    'Rundetårn i København er et historisk observatorium og udkigstårn. Bygget i det 17. århundrede, giver det besøgende en fantastisk udsigt over byen efter at have gået op ad sin snoede rampe.',
  ],
  'de-DE': [
    'Das Brandenburger Tor in Berlin ist ein Symbol der deutschen Einheit und Geschichte. Es hat viele historische Ereignisse miterlebt, von Napoleonischen Kriegen bis zum Fall der Berliner Mauer. Heute steht es als Mahnmal für Frieden und Freiheit und zieht Besucher aus aller Welt an.',
    'Der Schwarzwald ist ein malerisches Gebirge im Südwesten Deutschlands, bekannt für seine dichten Wälder und traditionelle Kuckucksuhren. Es ist ein beliebtes Ziel für Wanderer und Naturliebhaber.',
    'Das Schloss Neuschwanstein in Bayern ist eines der bekanntesten Schlösser der Welt. Mit seiner märchenhaften Architektur und atemberaubenden Lage in den Alpen zieht es jedes Jahr Millionen von Touristen an.',
  ],
  'el-GR': [
    'Η Ακρόπολη της Αθήνας είναι ένα από τα πιο σημαντικά αρχαιολογικά μνημεία στον κόσμο. Χτισμένη τον 5ο αιώνα π.Χ., αποτελεί σύμβολο του αρχαίου ελληνικού πολιτισμού και της δημοκρατίας. Κάθε χρόνο, χιλιάδες επισκέπτες θαυμάζουν την αρχιτεκτονική της και την ιστορία που κουβαλά.',
    'Το Παρθενώνας είναι το πιο διάσημο κτίριο στην Ακρόπολη και θεωρείται αριστούργημα της αρχιτεκτονικής. Χτίστηκε για να τιμήσει τη θεά Αθηνά, την προστάτιδα της πόλης.',
    'Η Σαντορίνη είναι ένα από τα πιο όμορφα νησιά της Ελλάδας, γνωστό για τα λευκά σπίτια της με τις μπλε στέγες και τα εκπληκτικά ηλιοβασιλέματα. Είναι ένας δημοφιλής προορισμός για ταξιδιώτες από όλο τον κόσμο.',
  ],
  'en-AU': [
    "The Great Barrier Reef is the world's largest coral reef system, located off the coast of Queensland, Australia. It is home to a vast array of marine life, including colorful corals, fish, and sea turtles. The reef is a natural wonder and a vital part of the ocean's ecosystem, attracting divers and tourists from around the globe.",
    'The Sydney Opera House is one of the most iconic buildings in the world. Its unique sail-like design makes it a symbol of Australia. Visitors can enjoy concerts, plays, and even guided tours of this architectural masterpiece.',
    "Uluru, also known as Ayers Rock, is a massive sandstone monolith in the heart of the Northern Territory's arid 'Red Centre'. It is a sacred site to the Aboriginal people and a popular tourist attraction for its striking red color and cultural significance.",
  ],
  'en-GB': [
    'Stonehenge is one of the most famous prehistoric monuments in the world, located in Wiltshire, England. The stone circle, dating back to around 2500 BC, has fascinated historians and archaeologists for centuries. Its purpose remains a mystery, but it stands as a testament to the ingenuity and creativity of ancient peoples.',
    'The Tower of London is a historic castle located on the north bank of the River Thames in central London. Founded towards the end of 1066 as part of the Norman Conquest, it has served as a royal palace, prison, armory, and even a zoo.',
    'The Lake District, located in northwest England, is a region known for its stunning scenery, including mountains, forests, and lakes. It has inspired many writers and poets, including William Wordsworth, and is a popular destination for hiking and boating.',
  ],
  'en-US': [
    'The Golden Gate Bridge is a suspension bridge spanning the Golden Gate, the strait connecting San Francisco Bay and the Pacific Ocean. It links the city of San Francisco, California, to Marin County to the north. Renowned for its striking International Orange color and Art Deco design, the bridge is an iconic symbol of San Francisco and one of the most photographed bridges in the world.',
    'The Grand Canyon is a steep-sided canyon carved by the Colorado River in Arizona, United States. It is largely contained within the Grand Canyon National Park, one of the first national parks in the United States. The Grand Canyon is known for its visually overwhelming size and its intricate and colorful landscape.',
    "In the twilight's embrace, when shadows dance and play, and the stars whisper secrets that only the night can say; in the silence of the moon, before the dawn's first light, the dreams of yesterday return and set our hearts alight.",
  ],
  'es-ES': [
    'La Alhambra, situada en Granada, España, es una joya de la arquitectura islámica. Construida en el siglo XIII, este palacio y fortaleza combina elementos artísticos y naturales de manera impresionante. Cada rincón cuenta una historia de la rica herencia cultural y la historia de Al-Andalus.',
    'El Parque Güell en Barcelona es uno de los trabajos más famosos de Antoni Gaudí. Este parque colorido y caprichoso ofrece vistas espectaculares de la ciudad y es un lugar donde la naturaleza y la arquitectura se fusionan de manera mágica.',
    'El Camino de Santiago es una antigua ruta de peregrinación que recorre toda España hasta la catedral de Santiago de Compostela. Cada año, miles de peregrinos de todo el mundo caminan por esta ruta buscando experiencias espirituales y culturales.',
  ],
  'es-US': [
    'El Parque Nacional Yellowstone, ubicado en los Estados Unidos, es famoso por sus géiseres, fuentes termales y diversa vida silvestre. Establecido en 1872, fue el primer parque nacional del mundo. Los visitantes pueden disfrutar de paisajes impresionantes y observar bisontes, osos y lobos en su hábitat natural.',
    'El Gran Cañón en Arizona es una maravilla natural que ofrece vistas espectaculares y una lección geológica impresionante. Formado durante millones de años por el río Colorado, sus capas de roca revelan la historia de la Tierra.',
    'La Estatua de la Libertad en Nueva York es un símbolo de libertad y democracia. Regalado por Francia en 1886, esta icónica estatua ha dado la bienvenida a millones de inmigrantes que llegaron a Estados Unidos en busca de una vida mejor.',
  ],
  'fi-FI': [
    'Suomenlinna on historiallinen merilinnoitus, joka sijaitsee Helsingin edustalla. Se rakennettiin 1700-luvulla suojaamaan Ruotsin valtakuntaa Venäjän uhalta. Nykyään se on suosittu matkailukohde ja UNESCO:n maailmanperintökohde, jossa voi tutustua Suomen historiaan ja nauttia kauniista merimaisemista.',
    'Lapin tunturit ja revontulet tarjoavat unohtumattomia elämyksiä. Talvella voit kokea huskyvaljakkoajelun, nähdä upeita jääveistoksia ja ehkäpä bongata poroja vaeltaessasi lumisessa maisemassa.',
    'Saunominen on olennainen osa suomalaista kulttuuria. Suomessa on noin 3 miljoonaa saunaa, ja saunominen on tapa rentoutua ja viettää aikaa perheen ja ystävien kanssa. Saunassa voit kokea suomalaisen rentoutumisen taian.',
  ],
  'fil-PH': [
    "Ang Banaue Rice Terraces ay kilala bilang 'Ikawalong Wonder ng Mundo.' Matatagpuan sa hilagang Luzon, Pilipinas, ang mga hagdan-hagdang palayan na ito ay inukit ng mga Ifugao higit sa 2,000 taon na ang nakalilipas. Ang kanilang kahusayan sa agrikultura at pagsisikap ay makikita sa bawat hakbang ng mga terrace na ito.",
    "Ang Chocolate Hills sa Bohol ay isang kakaibang pook na may higit sa 1,000 maliliit na burol. Kapag tag-araw, ang mga damo sa burol ay nagiging kulay tsokolate, kaya't nakuha nila ang kanilang pangalan. Ito ay isa sa mga pinakamagandang tanawin sa Pilipinas.",
    'Ang Mayon Volcano sa Albay ay kilala bilang perpektong hugis-apoy dahil sa kanyang simetrikong hugis. Bagaman ito ay aktibong bulkan, maraming turista ang pumupunta dito upang masaksihan ang kanyang kagandahan at katindihan.',
  ],
  'fr-CA': [
    'Le Vieux-Québec est un quartier historique de la ville de Québec, au Canada. Fondée en 1608, cette région est le berceau de la civilisation française en Amérique du Nord. Ses rues pavées, ses bâtiments historiques et son ambiance européenne attirent des milliers de visiteurs chaque année.',
    "Les chutes du Niagara sont une série de grandes chutes d'eau situées à la frontière entre le Canada et les États-Unis. Elles sont impressionnantes par leur puissance et leur beauté. Les visiteurs peuvent faire une croisière en bateau pour s'approcher des chutes et sentir la brume rafraîchissante.",
    'Le Mont-Royal est une colline emblématique située au cœur de Montréal. Il offre une vue panoramique sur la ville et est un lieu populaire pour les activités de plein air comme la randonnée, le vélo et le patinage en hiver.',
  ],
  'fr-FR': [
    "La tour Eiffel, située à Paris, est l'un des monuments les plus célèbres du monde. Construite en 1889 pour l'Exposition universelle, elle est devenue le symbole de la France. Chaque année, des millions de visiteurs montent au sommet pour admirer la vue imprenable sur la ville lumière.",
    "Le Louvre est le plus grand musée d'art du monde et un monument historique à Paris. Il abrite des milliers d'œuvres d'art, y compris la célèbre Mona Lisa. Une visite au Louvre est un voyage à travers l'histoire de l'art et des civilisations.",
    "Le Château de Versailles est une ancienne résidence royale située près de Paris. Connu pour ses jardins magnifiques et ses salles opulentes comme la Galerie des Glaces, Versailles est un symbole de la grandeur et de l'élégance française.",
  ],
  'gu-IN': [
    'ગિરનાર પર્વત, જે ગુજરાતના જૂનાગઢ શહેર નજીક આવેલો છે, હિન્દુઓ અને જૈનો બંને માટે મહત્વપૂર્ણ યાત્રાધામ છે. આ પર્વત ઉપર ઘણા મંદિર અને તીર્થસ્થળો છે, અને યાત્રાળુઓ આ પવિત્ર સ્થળના દર્શન કરવા માટે દુર દૂરથી આવે છે. ગિરનારની ઉંચાઈ અને તેની પ્રાકૃતિક સૌંદર્ય યાત્રાળુઓને પ્રેરણા આપે છે.',
    'કચ્છના રણમાં દર વર્ષે થતા રણ ઉત્સવમાં, સફેદ રેત પર આપને કલ્ચરલ શો અને અનેક આકર્ષણો જોવા મળે છે. રણની શાંતિ અને રંગીન ઉત્સવ એક અનોખી અનુભૂતિ આપે છે.',
    'સાબરમતી આશ્રમ, મહાત્મા ગાંધીનો રહેઠાણ, અમદાવાદમાં છે. આ સ્થાનેથી ગાંધીજી એ પોતાના સ્વાતંત્ર્ય આંદોલનનું નિર્માણ કર્યું હતું. આશ્રમની મુલાકાત થી આપણે મહાત્મા ગાંધીજીની જીવનશૈલી અને તેમના વિચારધારાને સમજી શકીએ છીએ.',
  ],
  'he-IL': [
    'הכותל המערבי בירושלים הוא אחד המקומות הקדושים ביותר ליהדות. הקיר נבנה במאה הראשונה לפני הספירה כחלק ממקדש הורדוס, והוא המקום האחרון שנותר מהמקדש הקדוש. כל שנה מגיעים מיליוני מבקרים להתפלל ולשים פתקים עם תפילות בין אבני הקיר.',
    'ים המלח הוא המקום הנמוך ביותר בעולם ונמצא בין ישראל לירדן. המים המלוחים שלו מאפשרים לכל אחד לצוף בקלות. חווית הציפה בים המלח היא ייחודית ומשעשעת.',
    'התיאטרון העתיק בקיסריה הוא אחד מהאתרים הארכיאולוגיים המרשימים בישראל. הוא נבנה בתקופת הורדוס ומשמש עד היום לאירועים והופעות תחת כיפת השמיים.',
  ],
  'hi-IN': [
    'ताजमहल, आगरा में स्थित, एक सफेद संगमरमर का मकबरा है जिसे मुगल सम्राट शाहजहाँ ने अपनी पत्नी मुमताज महल की याद में बनवाया था। इसे प्रेम का प्रतीक माना जाता है और यह विश्व धरोहर स्थल है। हर साल लाखों पर्यटक इसकी भव्यता और वास्तुकला की प्रशंसा करने आते हैं।',
    "जयपुर का हवा महल अपनी अद्वितीय वास्तुकला और सुंदरता के लिए प्रसिद्ध है। यह महल 'पैलेस ऑफ विंड्स' के नाम से भी जाना जाता है और इसमें 953 छोटी खिड़कियाँ हैं। ये खिड़कियाँ महल को ठंडा रखने और हवा के प्रवाह को बनाए रखने के लिए बनाई गई थीं।",
    "वाराणसी, जिसे बनारस भी कहा जाता है, भारत का सबसे प्राचीन शहर है और इसे 'मोक्ष की नगरी' के रूप में जाना जाता है। यहाँ गंगा नदी के घाट पर हर शाम होने वाली गंगा आरती देखने के लिए देश-विदेश से लोग आते हैं।",
  ],
  'hu-HU': [
    'A Budai Vár, Budapest egyik legikonikusabb látnivalója, a Duna fölött magasodik. A várnegyed számos történelmi épületet, múzeumot és templomot rejt, melyek mind a magyar történelem gazdagságát tükrözik.',
    'A Balaton, Közép-Európa legnagyobb tava, népszerű üdülőhely a helyiek és turisták körében egyaránt. A tó körüli kis falvak és városok nyugodt kikapcsolódást kínálnak, a vitorlázás és a strandolás szerelmeseinek.',
    'A Hortobágyi Nemzeti Park Magyarország egyik legnagyobb természetvédelmi területe. A puszta és a különleges madárvilág teszi egyedivé, ahol a látogatók megismerhetik a magyar pásztorkultúrát is.',
  ],
  'id-ID': [
    'Candi Borobudur di Jawa Tengah adalah candi Buddha terbesar di dunia. Dibangun pada abad ke-9, candi ini terkenal dengan stupa dan relief-relief yang menceritakan kehidupan Buddha. Setiap tahun, ribuan umat Buddha datang untuk merayakan Waisak di sini.',
    'Bali, pulau dewata, terkenal dengan pantai-pantainya yang indah, budaya yang kaya, dan pemandangan alam yang menakjubkan. Wisatawan dari seluruh dunia datang untuk berselancar, menyelam, dan menikmati keindahan alam serta upacara-upacara tradisional Bali.',
    'Gunung Bromo di Jawa Timur adalah salah satu gunung berapi yang paling terkenal di Indonesia. Pemandangan matahari terbit dari puncak gunung ini sangat memukau dan menjadi daya tarik utama bagi para pendaki dan fotografer.',
  ],
  'it-IT': [
    "Il Colosseo a Roma è uno dei più grandi anfiteatri del mondo e un simbolo dell'antica Roma. Costruito nel I secolo d.C., poteva ospitare fino a 50.000 spettatori per assistere a combattimenti di gladiatori e altri spettacoli. Oggi, il Colosseo è una delle principali attrazioni turistiche di Roma.",
    "Il Canal Grande di Venezia è il principale canale che attraversa la città. I palazzi storici che si affacciano sul canale e le gondole che lo percorrono rendono Venezia unica al mondo. Una gita in gondola è un'esperienza indimenticabile.",
    'Il Duomo di Milano, una delle cattedrali più grandi del mondo, è famoso per la sua architettura gotica e le sue numerose statue. La vista dalla terrazza della cattedrale offre uno spettacolo mozzafiato sulla città.',
  ],
  'ja-JP': [
    '富士山は日本で最も高い山で、美しい円錐形の火山として有名です。毎年、多くの登山者が夏に山頂を目指し、山頂からの日の出を楽しみます。富士山は日本の象徴であり、多くの芸術作品に描かれています。',
    '京都の金閣寺は、その美しい金色の外観で知られています。正式名称は鹿苑寺で、庭園とともに日本の伝統的な美を象徴しています。訪れる人々は四季折々の景色を楽しむことができます。',
    '東京の渋谷スクランブル交差点は、世界で最も忙しい交差点の一つです。一度に何百人もの人々が交差点を渡る光景は、まるで巨大なダンスのようです。',
  ],
  'kn-IN': [
    'ಮೈಸೂರು ಅರಮನೆ, ಭಾರತದ ಅತ್ಯಂತ ಸೌಂದರ್ಯದ ರಾಜಮನೆತನಗಳಲ್ಲಿ ಒಂದಾಗಿದೆ. ಇದರ ಅಲಂಕಾರಿಕ ವಾಸ್ತುಶಿಲ್ಪ ಮತ್ತು ದೀಪಾವಳಿಯ ದೀಪಾಲಂಕಾರ ವಿಶ್ವದ ಎಲ್ಲೆಡೆಯಿಂದ ಪ್ರವಾಸಿಗರನ್ನು ಆಕರ್ಷಿಸುತ್ತದೆ. ಸಾಂಸ್ಕೃತಿಕ ಕಾರ್ಯಕ್ರಮಗಳು ಮತ್ತು ಉತ್ಸವಗಳು ಇಲ್ಲಿ ಚರಿತ್ರೆಯ ಸೊಗಡನ್ನು ತಂದುಕೊಡುತ್ತವೆ.',
    'ಹಂಪಿಯ ಅವಶೇಷಗಳು ಕರ್ನಾಟಕದ ಪ್ರಮುಖ ಪುರಾತನ ಸ್ಥಳಗಳಲ್ಲಿ ಒಂದಾಗಿದ್ದು, ವಿಜಯನಗರ ಸಾಮ್ರಾಜ್ಯದ ಮುಖ್ಯ ಕೇಂದ್ರವಾಗಿತ್ತು. ಇದರ ವಾಸ್ತುಶಿಲ್ಪ, ಶಿಲ್ಪಕಲಾ ಮತ್ತು ತೇರುಹಬ್ಬಗಳು ಪ್ರವಾಸಿಗರಿಗೆ ಮಹದಾನಂದವನ್ನು ಕೊಡುತ್ತವೆ.',
    "ಬೆಂಗಳೂರು ನಗರವನ್ನು 'ಸಿಲಿಕಾನ್ ವ್ಯಾಲಿ ಆಫ್ ಇಂಡಿಯಾ' ಎಂದು ಕರೆಯಲಾಗುತ್ತದೆ. ಇದು ತಂತ್ರಜ್ಞಾನ ಉದ್ಯಮದ ಕೇಂದ್ರವಾಗಿದ್ದು, ಸಸ್ಯಶಾಸ್ತ್ರ ಉದ್ಯಾನ ಮತ್ತು ಜೀವನಶೈಲಿ ಮೂಲಕ ಹೊಸತನ್ನು ಪಡೆಯುತ್ತದೆ.",
  ],
  'ko-KR': [
    '서울의 경복궁은 조선 왕조의 궁궐 중 하나로, 아름다운 건축물과 정원이 어우러져 있습니다. 매년 많은 관광객이 방문하여 한국의 전통 문화를 체험합니다. 궁궐의 수문장 교대식은 인기 있는 볼거리 중 하나입니다.',
    '제주도는 한국의 대표적인 관광지로, 아름다운 해변과 화산섬으로 유명합니다. 제주도의 한라산은 등산객들에게 인기가 많으며, 봄에는 진달래꽃이 만발합니다.',
    '부산의 해운대 해수욕장은 한국에서 가장 유명한 해변 중 하나로, 여름철에는 많은 사람들이 해수욕과 해양 스포츠를 즐깁니다. 또한 해운대의 야경은 아름답기로 유명합니다.',
  ],
  'ml-IN': [
    'കുമാരകൊം കേരളത്തിലെ സുന്ദരമായ ബാക്ക്‌വാട്ടർ സ്ഥലങ്ങളിലൊന്നാണ്. ഇവിടെവരുന്ന സന്ദര്‍ശകര്‍ക്ക് ഹൗസ്‌ബോട്ടുകളില്‍ യാത്ര ചെയ്യാനും, സമാധാനവും സുന്ദര്യവും ആസ്വദിക്കാനുമുള്ള അവസരം ലഭിക്കുന്നു. കുമാരകൊത്തിന്റെ ശാന്തവും നിഷ്കളങ്കവുമായ പ്രകൃതി ഒരുപാട് സ്മരണകളും സമ്മാനിക്കുന്നു.',
    'മുന്നാര്‍ കേരളത്തിലെ പ്രശസ്തമായ ഹില്‍ സ്റ്റേഷനാണ്. ഏത് കാലാവസ്ഥയിലും കാഴ്ചയ്ക്ക് മനോഹരമായ ചായ തോട്ടങ്ങള്‍ ഇവിടത്തെ പ്രത്യേകതയാണ്. ദൂരെയുള്ള പുല്‍മേടുകളും, മലനിരകളും, തടാകങ്ങളും ഇവിടെ കാഴ്ചകള്‍ മനോഹരമാക്കുന്നു.',
    'ആലപ്പുഴയിലെ നെഞ്ചുറപ്പിക്കുന്ന ചെറുവള്ളം മത്സരങ്ങള്‍ ഓണക്കാലത്ത് വേറെ ഒരു പ്രകാശനമായി മാറുന്നു. വള്ളംകളി മാത്രമല്ല, പാറിച്ച ചതിയുള്ള പുഴയുടെ കാഴ്ചകളും ആസ്വദിക്കാനാവും.',
  ],
  'mr-IN': [
    'महाराष्ट्रातील अजिंठा आणि वेरूळ येथील लेण्या प्राचीन भारतीय वास्तुशिल्पाची उत्कृष्ट उदाहरणे आहेत. येथील कोरीवकाम आणि भित्तिचित्रे भारतीय इतिहासाची झलक देतात. या लेण्यांमध्ये बुद्ध धर्माच्या विविध टप्प्यांचे दर्शन होते.',
    'माथेरान हे महाराष्ट्रातील एक लोकप्रिय हिल स्टेशन आहे. येथे जाण्यासाठी पर्यटकांना खास टॉय ट्रेनचा अनुभव घेता येतो. माथेरानचे सुंदर निसर्गदृश्य आणि शांत वातावरण पर्यटकांना आकर्षित करते.',
  ],
  'ms-MY': [
    'Menara Kuala Lumpur adalah menara telekomunikasi yang terletak di tengah-tengah ibu kota Malaysia. Dengan ketinggian 421 meter, ia menawarkan pemandangan panoramik bandar yang menakjubkan. Menara ini juga menampilkan restoran berputar di bahagian atasnya.',
    'Taman Negara adalah taman nasional tertua di Malaysia dan merupakan rumah bagi hutan hujan tropis yang berusia lebih dari 130 juta tahun. Di sini, pengunjung dapat melakukan trekking, memerhatikan hidupan liar, dan menikmati jambatan kanopi yang menggembirakan.',
    'Pulau Langkawi terkenal dengan pantai-pantai indahnya, hutan hujan tropis, dan mitos serta legenda yang menarik. Langkawi adalah destinasi yang sempurna untuk bersantai dan menikmati keindahan alam.',
  ],
  'nb-NO': [
    'Fjorder i Norge er verdenskjente for sin skjønnhet. En fjord er en lang, smal havbukt med bratte sider, skapt av isbreer. Norges fjorder, som Sognefjorden og Geirangerfjorden, tiltrekker seg besøkende fra hele verden.',
    'Oslo, hovedstaden i Norge, er kjent for sin rike historie og moderne arkitektur. Byen har mange museer, parker og historiske steder som Vikingeskipshuset og Akershus festning.',
    'Nordlys, eller Aurora Borealis, er et spektakulært lysfenomen som kan sees i de nordlige delene av Norge. Dette naturfenomenet tiltrekker seg turister og forskere som ønsker å oppleve det magiske lysshowet på himmelen.',
  ],
  'nl-BE': [
    'De grachten van Amsterdam zijn beroemd over de hele wereld. Deze historische waterwegen, gebouwd in de 17e eeuw, geven de stad haar unieke karakter. Een boottocht door de grachten biedt een prachtig uitzicht op de oude huizen en bruggen.',
    'Keukenhof is een van de grootste bloementuinen ter wereld en bevindt zich in Nederland. Elke lente bloeien hier miljoenen tulpen, narcissen en hyacinten, waardoor het een spectaculaire kleurenpracht biedt.',
    'De Zaanse Schans is een openluchtmuseum in Nederland dat een kijkje geeft in het traditionele Nederlandse leven van de 18e en 19e eeuw. Hier kun je oude molens, klompenmakers en kaasmakerijen bezoeken.',
  ],
  'nl-NL': [
    'De grachten van Amsterdam zijn beroemd over de hele wereld. Deze historische waterwegen, gebouwd in de 17e eeuw, geven de stad haar unieke karakter. Een boottocht door de grachten biedt een prachtig uitzicht op de oude huizen en bruggen. Wist je dat er meer dan 1,500 bruggen in Amsterdam zijn? Elk met zijn eigen charme en geschiedenis.',
    'De Keukenhof, gelegen in Lisse, is een van de grootste bloementuinen ter wereld. Elk voorjaar bloeien hier miljoenen tulpen, narcissen en hyacinten, wat een spectaculaire kleurenpracht biedt. Het park trekt duizenden bezoekers die komen genieten van de adembenemende bloementapijten. Leuk weetje: er worden elk jaar meer dan zeven miljoen bloembollen geplant!',
    'De Zaanse Schans is een openluchtmuseum nabij Zaandam dat een kijkje geeft in het traditionele Nederlandse leven van de 18e en 19e eeuw. Hier kun je oude windmolens, klompenmakers en kaasmakerijen bezoeken. De Zaanse Schans is niet alleen een toeristische trekpleister, maar ook een plek waar je de Nederlandse ambachten kunt zien en ervaren. Wist je dat de Zaanse Schans jaarlijks meer dan een miljoen bezoekers verwelkomt?',
  ],
  'pa-IN': [
    'ਵਾਘਾ ਬਾਰਡਰ, ਭਾਰਤ ਅਤੇ ਪਾਕਿਸਤਾਨ ਦੇ ਦਰਮਿਆਨ ਸਥਿਤ ਹੈ, ਹਰ ਸ਼ਾਮ ਨੂੰ ਹੋਣ ਵਾਲੀ ਰੀਟ੍ਰੀਟ ਸਮਾਰੋਹ ਲਈ ਮਸ਼ਹੂਰ ਹੈ। ਇਹ ਸਮਾਰੋਹ ਦੇ ਅਖੀਰ ਵਿੱਚ ਦੋਨਾਂ ਦੇਸ਼ਾਂ ਦੇ ਝੰਡੇ ਨੂੰ ਹੰਭਣ ਅਤੇ ਸੈਨਾ ਦੀ ਝਲਕ ਪ੍ਰਦਰਸ਼ਿਤ ਕਰਦਾ ਹੈ।',
    'ਅੰਮ੍ਰਿਤਸਰ ਦਾ ਸ੍ਰੀ ਹਰਿਮੰਦਰ ਸਾਹਿਬ, ਜੋ ਸੋਨੇ ਦੇ ਮੰਦਰ ਵਜੋਂ ਜਾਣਿਆ ਜਾਂਦਾ ਹੈ, ਸਿੱਖ ਧਰਮ ਦਾ ਸਭ ਤੋਂ ਪਵਿੱਤਰ ਤੀਰਥਸਥਾਨ ਹੈ। ਇਹ ਮੰਦਰ ਆਪਣੇ ਸ਼ਾਂਤਮਈ ਥਾਂ ਅਤੇ ਸੁੰਦਰਤਾ ਲਈ ਮਸ਼ਹੂਰ ਹੈ।',
    'ਚੰਡੀਗੜ੍ਹ ਦੀ ਰਾਕ ਗਾਰਡਨ ਇੱਕ ਕਲਾ ਦੇ ਆਸ਼ੀਕਾਂ ਲਈ ਜੰਨਤ ਹੈ। ਇਸ ਬਾਗ ਵਿੱਚ ਹਜ਼ਾਰਾਂ ਮੂਰਤੀਆਂ ਹਨ ਜੋ ਉੱਡੀਅਨ ਸਮੱਗਰੀ ਤੋਂ ਬਣਾਈਆਂ ਗਈਆਂ ਹਨ। ਇਹ ਬਾਗ ਇੱਕ ਕਲਾਤਮਿਕ ਅਦਾਕਾਰੀ ਦਾ ਸ਼ਾਨਦਾਰ ਉਦਾਹਰਣ ਹੈ।',
  ],
  'pl-PL': [
    'Wawel w Krakowie jest jednym z najważniejszych zabytków w Polsce. Zamek na Wawelu był przez wieki siedzibą królów polskich i miejscem koronacji. Dziś jest to muzeum pełne historii i sztuki.',
    'Warszawska Starówka, odbudowana po zniszczeniach drugiej wojny światowej, jest sercem stolicy Polski. Spacer po jej uliczkach to podróż w czasie, gdzie historia spotyka się z nowoczesnością.',
    'Mazury, kraina tysiąca jezior, to raj dla miłośników żeglarstwa i przyrody. Piękne krajobrazy, czyste jeziora i urokliwe miasteczka przyciągają turystów z całego świata.',
  ],
  'pt-BR': [
    'O Cristo Redentor, localizado no Rio de Janeiro, é uma das sete maravilhas do mundo moderno. Esta estátua icônica oferece uma vista panorâmica incrível da cidade e é um símbolo de paz e acolhimento.',
    'A Floresta Amazônica é a maior floresta tropical do mundo e é conhecida como o pulmão do planeta. Ela abriga uma biodiversidade incomparável, com milhares de espécies de plantas e animais.',
    'O Carnaval de Salvador é um dos maiores e mais animados do mundo. Durante o Carnaval, as ruas da cidade são tomadas por desfiles de blocos e trios elétricos, onde milhões de pessoas dançam e celebram juntas.',
  ],
  'pt-PT': [
    'A Torre de Belém em Lisboa é um monumento histórico e uma das joias arquitetônicas de Portugal. Construída no século XVI, a torre serviu como uma fortaleza para proteger a cidade e hoje é um ícone da era dos descobrimentos.',
    'O Mosteiro dos Jerónimos, também em Lisboa, é um exemplo impressionante da arquitetura manuelina. Este mosteiro foi construído em homenagem às descobertas de Vasco da Gama e é um patrimônio mundial da UNESCO.',
    'O Douro Vinhateiro é uma região de Portugal famosa por suas vinhas e paisagens deslumbrantes. Aqui é produzido o famoso vinho do Porto, e os visitantes podem desfrutar de passeios de barco pelo rio Douro e visitas às vinícolas locais.',
  ],
  'ro-RO': [
    "Castelul Bran, situat în România, este cunoscut în întreaga lume ca 'Castelul lui Dracula.' Deși legăturile cu Vlad Țepeș sunt mai mult mitice, castelul atrage turiști datorită istoriei sale fascinante și arhitecturii impresionante.",
    'Delta Dunării este una dintre cele mai mari și mai bine conservate delte din Europa. Aici, biodiversitatea este extraordinară, cu sute de specii de păsări și pești, și peisaje naturale de o frumusețe rară.',
    "Mănăstirea Voroneț, cunoscută pentru frescele sale exterioare de un albastru intens, este adesea numită 'Capela Sixtină a Estului.' Această mănăstire medievală este un exemplu superb de artă și spiritualitate ortodoxă.",
  ],
  'ru-RU': [
    'Красная площадь в Москве является одним из самых известных мест в России. Здесь находится мавзолей Ленина, Кремль и Собор Василия Блаженного с его яркими куполами, символизирующими русскую архитектуру.',
    'Эрмитаж в Санкт-Петербурге - один из крупнейших и старейших художественных музеев мира. В нем хранится более трех миллионов произведений искусства, от древних артефактов до шедевров эпохи Возрождения.',
    'Озеро Байкал в Сибири - самое глубокое и старейшее пресноводное озеро в мире. Его кристально чистая вода и уникальная экосистема привлекают ученых и туристов со всего мира.',
  ],
  'sk-SK': [
    'Bratislavský hrad sa týči nad hlavným mestom Slovenska, Bratislavou. Hrad má bohatú históriu a ponúka nádherné výhľady na Dunaj a mesto. Je to významná turistická atrakcia a symbol slovenského národa.',
    'Tatry sú najvyšším pohorím na Slovensku a obľúbeným miestom pre turistov a lyžiarov. Majestátne vrcholy, malebné doliny a horské jazerá tvoria krásnu krajinu, ktorá láka návštevníkov v každom ročnom období.',
    'Spišský hrad je jedným z najväčších hradných komplexov v Európe. Tento stredoveký hrad ponúka návštevníkom možnosť preskúmať históriu a užiť si úžasné výhľady na okolité hory a dediny.',
  ],
  'sv-SE': [
    'Stockholms skärgård är en av Sveriges mest älskade naturupplevelser. Den består av tusentals öar och holmar, varav många är obebodda. Här kan du segla, paddla kajak eller bara njuta av den vackra naturen.',
    'Gamla Stan i Stockholm är stadens historiska hjärta. Med sina kullerstensgator och färgglada byggnader från medeltiden, är det en plats full av historia och charm. Här ligger även Kungliga slottet.',
    'Abisko nationalpark i norra Sverige är känd för sina fantastiska möjligheter att se norrsken. Parken erbjuder också vacker fjällmiljö med vandringsleder som Kungsleden, en av världens mest kända vandringsleder.',
  ],
  'ta-IN': [
    'மதுரை நகரில் அமைந்துள்ள மீனாட்சி அம்மன் கோவில் தமிழ்நாட்டின் முக்கிய ஆன்மீக மையமாகும். கோவில் தனது வியத்தகு கோபுரங்கள் மற்றும் சிற்பங்களுக்குப் பிரபலமாக உள்ளது. ஆண்டுதோறும் நடைபெறும் திருவிழாக்கள் இலட்சக்கணக்கான பக்தர்களை ஈர்க்கின்றன.',
    'மஹாபலிபுரம் ஒரு பிரபலமான யுனெஸ்கோ உலக பாரம்பரிய தலம் ஆகும். இது கடற்கரை நகரமாகும் மற்றும் அதன் ரதங்கள் மற்றும் சரியான நக்கல் கற்சிற்பங்களுக்காக புகழ்பெற்றது.',
    'கொடைக்கானல் ஒரு பிரபலமான மலையிடை ஊர் ஆகும். இதன் குளிர்ச்சியான காலநிலை மற்றும் பசுமையான சூழல் சுற்றுலாப் பயணிகளை கவர்கின்றது. சிலுவை சுருளை நடைபயணம் மற்றும் வில்சன் நீர்வீழ்ச்சி பிரபலமான இடங்கள் ஆகும்.',
  ],
  'th-TH': [
    'วัดพระแก้วในกรุงเทพมหานครเป็นวัดที่สำคัญที่สุดในประเทศไทย เป็นที่ประดิษฐานของพระแก้วมรกตซึ่งเป็นพระพุทธรูปสำคัญของชาติ วัดพระแก้วมีสถาปัตยกรรมที่งดงามและเต็มไปด้วยรายละเอียดที่ประณีต',
    'เชียงใหม่เป็นเมืองที่มีวัฒนธรรมและประวัติศาสตร์ที่ยาวนาน มีวัดมากมายที่สะท้อนถึงสถาปัตยกรรมล้านนา วัดพระธาตุดอยสุเทพเป็นที่รู้จักอย่างแพร่หลายและมีทัศนียภาพที่งดงามของเมืองเชียงใหม่',
    'อุทยานแห่งชาติเขาใหญ่เป็นหนึ่งในอุทยานแห่งชาติที่ใหญ่ที่สุดในประเทศไทย มีความหลากหลายทางชีวภาพสูงและเป็นที่อยู่อาศัยของสัตว์ป่าหลายชนิด นักท่องเที่ยวสามารถเดินป่าและชมธรรมชาติที่งดงาม',
  ],
  'tr-TR': [
    "Ayasofya, İstanbul'da yer alan ve Bizans İmparatoru I. Justinianus tarafından 537 yılında tamamlanan bir katedraldir. Osmanlı döneminde camiye dönüştürülen Ayasofya, günümüzde müze olarak hizmet vermektedir ve dünyanın en önemli mimari eserlerinden biridir.",
    "Kapadokya, Türkiye'nin merkezinde yer alan büyüleyici bir bölgedir. Peri bacaları, yer altı şehirleri ve sıcak hava balonlarıyla ünlüdür. Kapadokya, her yıl binlerce turisti kendine çeker.",
    "Pamukkale, Türkiye'nin batısında yer alan doğal bir oluşumdur. Beyaz traverten terasları ve sıcak su kaynakları ile ünlüdür. Hierapolis antik kenti ile birlikte UNESCO Dünya Mirası Listesi'nde yer almaktadır.",
  ],
  'uk-UA': [
    'Києво-Печерська лавра - один з найважливіших православних монастирів в Україні. Заснований у 11 столітті, він відомий своїми печерами і соборами. Лавра є духовним центром України і важливим місцем паломництва.',
    'Карпати - мальовничі гори на заході України, відомі своїми лісами, річками і традиційними гуцульськими селами. Це популярне місце для туризму і відпочинку, де можна насолодитися природою і культурою.',
    'Львів - культурна столиця України, відома своєю архітектурою, кафе і атмосферою середньовічного міста. Історичний центр Львова внесено до списку Світової спадщини ЮНЕСКО.',
  ],
  'ur-IN': [
    'مکلی کا قبرستان، جو سندھ، پاکستان میں واقع ہے، دنیا کے سب سے بڑے قبرستانوں میں سے ایک ہے۔ یہاں پر مختلف ادوار کی تاریخی قبریں موجود ہیں جو سندھ کی قدیم تاریخ کو بیان کرتی ہیں۔',
    'شالیمار باغ لاہور میں واقع ہے اور یہ مغل بادشاہ شاہجہاں کے دور میں تعمیر کیا گیا تھا۔ یہ باغ اپنے خوبصورت فواروں، باغات اور پویلین کے لئے مشہور ہے۔',
    'موہنجو داڑو، جو سندھ، پاکستان میں واقع ہے، قدیم سندھ کی تہذیب کا ایک اہم شہر تھا۔ یہ یونیسکو کی عالمی ورثہ کی فہرست میں شامل ہے اور قدیم تہذیبوں کی تحقیق کا اہم مرکز ہے۔',
  ],
  'vi-VN': [
    'Vịnh Hạ Long, nằm ở phía bắc Việt Nam, là một trong những kỳ quan thiên nhiên của thế giới. Với hàng ngàn hòn đảo đá vôi lớn nhỏ nổi bật trên mặt biển xanh biếc, vịnh Hạ Long là điểm đến mơ ước của nhiều du khách.',
    'Phố cổ Hội An, nằm ở miền trung Việt Nam, là một di sản thế giới được UNESCO công nhận. Hội An nổi tiếng với những ngôi nhà cổ, đèn lồng lung linh và các cửa hàng thủ công truyền thống.',
    'Thủ đô Hà Nội, với lịch sử ngàn năm, là trung tâm văn hóa và chính trị của Việt Nam. Hà Nội hấp dẫn du khách với những hồ nước yên bình, các công trình kiến trúc cổ kính và ẩm thực đa dạng.',
  ],
}

export { AUTODETECT_VOICE, DEFAULT_ENGLISH_VOICE, EXAMPLES, voices }
